module.exports = __webpack_public_path__ + "niall-4a1e736f37e7226dbfa89caa2ea778af.webp";